<script setup lang="ts">
import { FaqItem } from "@/views/FaqPage/FaqPage.vue";
import { addToDataLayer } from "@/services/gtm.service";

declare const _platformId: number;

const props = defineProps<{
    parentId: string,
    faqItem: FaqItem
}>()

const onClick = (question: string, event: Event) => {
    const clickedElement = event.target as HTMLElement;
    const expanded = !(clickedElement.getAttribute('aria-expanded') == 'true');
    const data = {
        'faq_status': expanded ? 'open' : 'closed',
        'faq_name': question,
    };
    addToDataLayer('faq_click', data);
}

const headingId = `${props.parentId}-heading-${props.faqItem.NodeId}`;
const collapseId = `${props.parentId}-collapse-${props.faqItem.NodeId}`;
</script>

<template>
    <div class="panel panel-default" role="tab">
        <a role="button" data-toggle="collapse" class="faq-item-heading collapsed text-decoration-none" :id="headingId"
            :data-parent="'#' + parentId" :href="'#' + collapseId" aria-expanded="false" :aria-controls="collapseId"
            @click="onClick(faqItem.Question, $event)">
            <h3 class="h4 faq-item-title">{{ faqItem.Question }}</h3>
            <span class="icon icon-plus" aria-hidden="true"></span>
            <span class="icon icon-minus" aria-hidden="true"></span>
        </a>
        <div :id="collapseId" class="panel-collapse collapse in" role="tabpanel" :aria-labelledby="headingId">
            <div class="faq-item-body" v-html="faqItem.Answer" />
        </div>
    </div>
</template>